<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <p class="t-left font-S14 fontC-4fa1a4 mb20" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <el-row :gutter="24">
        <el-col :span="7"
          ><div class="search-area-div">核算单元：</div>
          <el-input v-model="page.label" class="ipt-sty" placeholder="请输入核算单元"></el-input
        ></el-col>

        <el-col :span="8">
          <div>
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty">清空</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addBizUnit">新增核算单元</el-button>
      <span style="margin-left: 20px; font-size: 14px">提示：用于区分组织或者商品应用于哪个业务部门</span>
      <div class="fr line-h40 h40 font-S16 mr16">{{tenantName}}，有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个核算单元</div>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%"  :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="创建人"
          header-align="center"
          align="center"
          width="150"
          fixed="left"
        ></el-table-column>

        <el-table-column prop="label" label="核算单元名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.label }}</template>
        </el-table-column>

        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>

        <el-table-column prop="bank" min-width="150px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editUnit(scope.row.guid, scope.row.label)">编辑 | </a>
            <a class="txt-color" @click="checkUnit(scope.row.guid)">删除 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible1" width="40%">
      <el-form>
        <el-form-item label="　*药企方名称:" style="display: flex;justify-content:center;">
          <el-input v-model="tenantName" autocomplete="off" style="width: 300px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="*核算单元名称:" style="display: flex;justify-content:center;">
          <el-input style="width: 300px" type="text" placeholder="请输入核算单元名称" v-model="label"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增核算单元'"
          @click="addBizUnitInterface"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateBizUnitInterface"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增核算单元',
      dialogVisible1: false,
      tableData:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        label: '',
      },
      label: '',
      tenantGuid: '',
      tenantName: this.$route.query.tenantName,
      dialogVisible1: false,
      rowGuid: '',
      height: window.innerHeight - 360,
      tenantName:'',
    };
  },
  created() {
    this.tenantName = this.$route.query.tenantName;
    // 列表
    this.getData();
  },
  watch: {},
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: self.$route.query.tenantGuid,
        userName: '',
        startTime: '',
        endTime: '',
        province: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.$route.query.tenantGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = [];
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //新增核算单元
    addBizUnit() {
      this.textTitle = '新增核算单元';
      this.label = '';
      this.dialogVisible1 = true;
    },
    //确定
    addBizUnitInterface() {
      var self = this;
      if (!this.label) {
        self.$message.error('核算单元名称不能为空');
        return;
      }
      var query = {
        tenantGuid: self.$route.query.tenantGuid,
        label: this.label,
      };
      self.fullscreenLoading = true;
      self.dialogVisible1 = false;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/edit-biz-unit`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE||res.data == '') {
          self.$message.success('新增成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    editUnit(guid, label) {
      this.textTitle = '编辑核算单元';
      this.dialogVisible1 = true;
      this.rowGuid = guid;
      this.label = label;
    },
    //修改
    updateBizUnitInterface() {
      
      var self = this;
      if (!this.label) {
        self.$message.error('核算单元名称不能为空');
        return;
      }
      var query = {
        guid: this.rowGuid,
        tenantGuid: self.$route.query.tenantGuid,
        label: this.label,
      };
      self.fullscreenLoading = true;
      self.dialogVisible1 = false;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/edit-biz-unit`, query).then((res) => {
        console.log(res);
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE||res.data == '') {
          self.$message.success('修改成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除单元
    checkUnit(guid){
      var self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/check-biz-unit`, {
          guid: guid,
        })
        .then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data){
          this.$alert('该核算单元正在使用，无法删除');
          }else{
           self.deleteUnit(guid);
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    deleteUnit(guid) {
      var self = this;
      this.$confirm('确认删除该核算单元？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/del-biz-unit`, {
            guid: guid,
          })
          .then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>